import enviro from 'enviro';
import Raven from 'raven-js';
let isMetricsDebugEnabled = undefined;
export function getIsMetricsDebugEnabled() {
  if (isMetricsDebugEnabled !== undefined) {
    return isMetricsDebugEnabled;
  }
  try {
    // Enable via localStorage key or global flag
    // localStorage: set PERFORMANCE_METRICS_DEBUG=true in DevTools
    // global: set window.__PERFORMANCE_METRICS_DEBUG = true
    const ls = typeof localStorage !== 'undefined' && localStorage.getItem('PERFORMANCE_METRICS_DEBUG') === 'true';
    const globalFlag = typeof window !== 'undefined' && window.__PERFORMANCE_METRICS_DEBUG === true;
    isMetricsDebugEnabled = Boolean(ls || globalFlag);
    return isMetricsDebugEnabled;
  } catch (e) {
    return false;
  }
}
export function logMetric(name, tags, value) {
  const logger = enviro.isProd() ? Raven.capturePageEvent : console.info;
  const errorLogger = enviro.isProd() ? Raven.captureException : console.error;
  if (!getIsMetricsDebugEnabled()) return;
  try {
    if (typeof value === 'number') {
      // eslint-disable-next-line no-console
      logger('[metrics]', name, value, tags || {});
    } else {
      // eslint-disable-next-line no-console
      logger('[metrics]', name, tags || {});
    }
  } catch (e) {
    errorLogger('[metrics]', name, value, tags || {}, e);
  }
}
export function logEvent(name, tags) {
  const logger = enviro.isProd() ? Raven.capturePageEvent : console.info;
  const errorLogger = enviro.isProd() ? Raven.captureException : console.error;
  if (!getIsMetricsDebugEnabled()) return;
  try {
    // eslint-disable-next-line no-console
    logger('[metrics:event]', name, tags || {});
  } catch (e) {
    errorLogger('[metrics:event]', name, tags || {}, e);
  }
}
export function logLoadTimeTimeline(data) {
  if (!getIsMetricsDebugEnabled()) return;
  const {
    componentName,
    mountStart,
    mountEnd,
    mountDuration,
    timeToMount,
    readyTime,
    timeToReady
  } = data;

  // eslint-disable-next-line no-console
  console.info('[perf] ─── Page Load Timeline ───');
  // eslint-disable-next-line no-console
  console.info('[perf] 0ms      Navigation start');
  // eslint-disable-next-line no-console
  console.info(`[perf] ${mountStart.toFixed(0).padStart(6)}ms  ${componentName}:mount-start`);
  // eslint-disable-next-line no-console
  console.info(`[perf] ${mountEnd.toFixed(0).padStart(6)}ms  ${componentName}:mount-end [${mountDuration.toFixed(1)}ms]`);
  if (readyTime !== undefined && timeToReady !== undefined) {
    // eslint-disable-next-line no-console
    console.info(`[perf] ${readyTime.toFixed(0).padStart(6)}ms  ${componentName}:ready (data loaded)`);
  }

  // eslint-disable-next-line no-console
  console.info(`[perf] Time to mount: ${timeToMount.toFixed(1)}ms`);
  if (timeToReady !== undefined) {
    // eslint-disable-next-line no-console
    console.info(`[perf] Time to ready: ${timeToReady.toFixed(1)}ms`);
  }
}
export function logBlockingScriptsTable(scripts) {
  if (!getIsMetricsDebugEnabled()) return;
  if (scripts.length === 0) return;
  console.info('[perf] ─── Blocking Scripts ───');
  const sorted = [...scripts].sort((a, b) => b.duration - a.duration);
  for (const script of sorted) {
    const path = extractScriptPathForDisplay(script.sourceURL);
    const funcName = script.sourceFunctionName !== 'anonymous' ? ` (${script.sourceFunctionName})` : '';
    // eslint-disable-next-line no-console
    console.info(`[perf] ${path}: ${script.duration.toFixed(1)}ms${funcName}`);
  }
  const totalBlocking = scripts.reduce((sum, s) => sum + s.duration, 0);
  // eslint-disable-next-line no-console
  console.info(`[perf] Total blocking time: ${totalBlocking.toFixed(1)}ms`);
}
function extractScriptPathForDisplay(sourceURL) {
  if (!sourceURL || sourceURL === 'unknown') {
    return 'unknown';
  }
  try {
    const url = new URL(sourceURL, window.location.origin);
    return url.pathname;
  } catch (_unused) {
    const match = sourceURL.match(/\/[^?#]+/);
    return match ? match[0] : sourceURL;
  }
}
export function logPageLoadSummary(data) {
  if (!getIsMetricsDebugEnabled()) return;
  const {
    timeToMount,
    timeToReady,
    blockingScripts,
    importTimings
  } = data;

  // eslint-disable-next-line no-console
  console.info('[perf] ═══ Page Load Summary ═══');
  if (timeToMount !== undefined) {
    // eslint-disable-next-line no-console
    console.info(`[perf] Time to mount: ${timeToMount.toFixed(1)}ms`);
  }
  if (timeToReady !== undefined) {
    // eslint-disable-next-line no-console
    console.info(`[perf] Time to ready: ${timeToReady.toFixed(1)}ms`);
  }
  if (importTimings && importTimings.length > 0) {
    // eslint-disable-next-line no-console
    console.info('[perf] ─── Imports ───');
    const sorted = [...importTimings].sort((a, b) => b.duration - a.duration);
    for (const imp of sorted) {
      // eslint-disable-next-line no-console
      console.info(`[perf]   ${imp.name}: ${imp.duration.toFixed(1)}ms`);
    }
    const totalImport = importTimings.reduce((sum, i) => sum + i.duration, 0);
    // eslint-disable-next-line no-console
    console.info(`[perf] Total import time: ${totalImport.toFixed(1)}ms`);
  }
  if (blockingScripts && blockingScripts.length > 0) {
    logBlockingScriptsTable(blockingScripts);
  }

  // eslint-disable-next-line no-console
  console.info('[perf] ═══════════════════════════');
}